import 'moment/locale/nb';
import React from 'react';
import {
  int,
} from 'src/utils/misc.utils';
import {
  weeksInYear,
} from 'src/utils/date.utils';
import {
  SmallInputField,
  IncrementDecrementBtn,
} from './Components';
import {
  getCurrentWeek, getCurrentYear, getCurrentMoment,
} from './util';
import { InfoBubble } from '../../components/InfoBubble';
import {
  Label,
  Row,
} from '../../components/Layout';

export const WeekPicker = ({
  wanted_pickup_week,
  wanted_pickup_year,
  setWantedPickupWeek,
  setWantedPickupBasisYear,
  getIsWantedPickupBasisWeekValid,
  getGoneOverDeadlineForDefaultWeek,
  getInfoForSelectedPickupWeek,
  isSelectedWeekAndYearValidForPickup,
  getPickupDateWording,
}) => {
  const wantedPickupWeekStartDayInMonth = int(getCurrentMoment()
    .year(wanted_pickup_year)
    .week(wanted_pickup_week)
    .startOf('isoWeek')
    .format('D'));

  const wantedPickupWeekEndDayInMonth = int(getCurrentMoment()
    .year(wanted_pickup_year)
    .week(wanted_pickup_week)
    .endOf('isoWeek')
    .format('D'));

  return (
    <>
      <div
        style={{
          marginBottom: '0.5em',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ position: 'relative' }}>
            <Label
              inline
              bold
              marginRight="0.5em"
              cent
              style={{ display: 'inline-block' }}
            >
              {getPickupDateWording()}

              {': '}
              {!getIsWantedPickupBasisWeekValid([
                wanted_pickup_year,
                wanted_pickup_week,
              ])
                ? `uke ikke tilgjengelig.${!isSelectedWeekAndYearValidForPickup()
                  ? 'Se «?»'
                  : ''}`
                : `Uke ${wanted_pickup_week}`}
            </Label>

            {getGoneOverDeadlineForDefaultWeek() && (
              <Label>
                Frist for innmelding denne uken er gått
                ut. Prøv neste uke.
              </Label>
            )}
          </div>

          {(!isSelectedWeekAndYearValidForPickup() && (
            <Label
              inline
              style={{ display: 'inline-block' }}
            >
              <InfoBubble
                popupStyle={{
                  position: 'absolute',
                  top: '26px',
                  left: '-190px',
                  minWidth: '12em',
                }}
                style={{
                  position: 'absolute',
                  marginLeft: '8px',
                  marginTop: '-2px',
                  fontSize: '1.2em',
                }}
              >
                <p>
                  {getInfoForSelectedPickupWeek().reason}
                </p>
              </InfoBubble>
            </Label>
          )) || ''}
        </div>

        {(getIsWantedPickupBasisWeekValid([
          wanted_pickup_year,
          wanted_pickup_week,
        ]) && (
          <Label inline>
            (
            {getCurrentMoment()
              .year(wanted_pickup_year)
              .week(wanted_pickup_week)
              .startOf('isoWeek')
              .format(`D.${wantedPickupWeekStartDayInMonth > wantedPickupWeekEndDayInMonth
                ? 'MMM' /* The week spans several months and we would like to also display the from-month */
                : ''}`)}
            &ndash;
            {getCurrentMoment()
              .year(wanted_pickup_year)
              .week(wanted_pickup_week)
              .endOf('isoWeek')
              .format('D.MMM')}
            )
            {' '}
            {wanted_pickup_year !== getCurrentYear()
              ? wanted_pickup_year
              : ''}
            :
          </Label>
        )) || ''}
      </div>
      <Row
        align="center"
        style={{ alignSelf: 'center' }}
      >
        <IncrementDecrementBtn
          role="button"
          aria-label="mink uke"
          size="1.5em"
          padding="0.5em"
          onClick={() => {
            if (Number.isNaN(wanted_pickup_week)) {
              return;
            }

            const weekInt = parseInt(
              wanted_pickup_week,
              10,
            );
            if (weekInt - 1 === 0) {
              setWantedPickupWeek(
                weeksInYear(wanted_pickup_year - 1),
              );
              setWantedPickupBasisYear((old) => old - 1);
            } else {
              setWantedPickupWeek(weekInt - 1);
            }
          }}
        >
          -
        </IncrementDecrementBtn>
        <SmallInputField
          style={{ height: '4.2em' }}
          valid={getIsWantedPickupBasisWeekValid([
            wanted_pickup_year,
            wanted_pickup_week,
          ])}
          name="weekselect"
          value={wanted_pickup_week}
          onChange={(evt) => {
            const week = evt.target.value;
            setWantedPickupWeek(week);
          }}
        />
        <IncrementDecrementBtn
          role="button"
          size="1.5em"
          padding="0.5em"
          onClick={() => {
            if (Number.isNaN(wanted_pickup_week)) {
              return;
            }

            const weekInt = parseInt(
              wanted_pickup_week,
              10,
            );
            if (weekInt + 1 > weeksInYear(wanted_pickup_year)) {
              setWantedPickupWeek(1);
              setWantedPickupBasisYear((old) => old + 1);
            } else {
              setWantedPickupWeek(weekInt + 1);
            }
          }}
        >
          +
        </IncrementDecrementBtn>
      </Row>

      <Label
        color="#777777"
        size="0.8em"
        justify="center"
        marginTop="0.35em"
      >
        <span aria-hidden="true">*</span>
        Vi er nå i uke
        {' '}
        {getCurrentWeek()}
      </Label>
    </>
  );
};
